<template>
  <div class="map">
    <div ref="map" class="map-canvas"></div>
  </div>
</template>

<script>
  import CustomOverlay from '@/services/marker.js'

  export default {
    props: {
      mode: {  // overview :: profile
        required: true,
        type: String
      },

      children: {
        required: false,
        type: Array
      },

      child: {
        required: false,
        type: Object
      }
    },

    data() {
      return {
        mapOptions: {
          mapTypeControl: false
        },
        mapBounds: '',
        map: '',
        markers: [],
        tooltips: []
      }
    },

    mounted() {
      this.createMap()
      google.maps.event.addListenerOnce(
        this.map,
        'bounds_changed',
        this.onBoundsChange
      )

      if (this.mode === 'overview') {
        this.createOverviewMarkers(this.children)
        this.extendMapBoundsMultiple(this.children)
      } else if (this.mode === 'profile') {
        this.createLocationTooltip(this.child)
        this.extendMapBoundsSingle(this.child)
      }
    },

    methods: {
      createMap() {
        this.map = new google.maps.Map(
          this.$refs.map, {
            ...this.mapOptions,
            disableDefaultUI: this.$mq === 'mobile'
          }
        )
      },

      extendMapBoundsSingle(child) {
        this.mapBounds = new google.maps.LatLngBounds()

        this.mapBounds.extend({
          lat: child.latest_location.latitude,
          lng: child.latest_location.longitude
        })

        this.map.fitBounds(this.mapBounds)
      },

      extendMapBoundsMultiple(children) {
        this.mapBounds = new google.maps.LatLngBounds()

        children.forEach(child => {
          this.mapBounds.extend({
            lat: child.latest_location.latitude,
            lng: child.latest_location.longitude
          })
        })

        this.map.fitBounds(this.mapBounds)
      },

      onBoundsChange() {
        if (this.map.getZoom() > 15) {
          this.map.setZoom(15)
        }

        this.map.setZoom(this.map.getZoom() - 1)
      },

      createMarker(child) {
        this.markers.push(
          new CustomOverlay({
            type: 'marker',
            map: this.map,
            body: child
          })
        )
      },

      createOverviewMarkers(children) {
        children.forEach(child => {
          this.createMarker(child)
        })
      },

      createLocationTooltip(child) {
        this.removeTooltips()
        this.map.setZoom(15)
        this.map.panTo({
          lat: child.latest_location.latitude,
          lng: child.latest_location.longitude
        })

        this.tooltips.push(
          new CustomOverlay({
            type: 'tooltip',
            map: this.map,
            body: child
          })
        )
      },

      removeMarkers() {
        while (this.markers.length) {
          this.markers.pop().setMap(null)
          this.markers.length = 0
        }
      },

      removeTooltips() {
        while (this.tooltips.length) {
          this.tooltips.pop().setMap(null)
          this.tooltips.length = 0
        }
      }
    },

    watch: {
      child() {
        this.createLocationTooltip(this.child)
      },

      children: {
        handler: function() {
          if (this.mode === 'overview') {
            this.createOverviewMarkers(this.children)
          }
        },
        deep: true,
        immediate: true
      }
    }
  }
</script>

<style lang="scss">
  .map {
    height: 100%;

    .map-canvas {
      position: relative;
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
      background: #fff;

      .marker {
        background: url('~@/assets/images/marker.png');
        background-size: 60px 74px;
        background-repeat: no-repeat;
        font-size: 16px;
        position: absolute;
        cursor: pointer;
        width: 60px;
        height: 74px;
        margin: -84px 0 0 -30px;
        padding: 0;
      }

      .marker {
        .child-avatar {
          margin: 5px auto 0;
        }
      }

      .tooltip {
        font-size: 16px;
        position: absolute;
        cursor: pointer;
        width: 220px;
        height: 100px;
        margin: -100px 0 0 -110px;
        padding: 0;
      }
    }
  }
  
</style>
